<template>
    <div class="blog__list">
        <div class="item" v-for="item in array">
            <div class="left">
                <img v-simple-parallax="{ scale: 1.5, delay: 0.4 }" :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="Изображение">
            </div>
            <div class="right">
                <div class="text">{{ item.published_at }}</div>
                <div class="title">{{ item.title}}</div>
                <div class="desc">{{ item.description}}</div>
                <router-link :to="{
                    name: 'ArticleBlog',
                    params: {
                    slug: item.slug
                    },
                }">
                        <svg width="24.000000" height="24.000000" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <clipPath id="clip409_2813">
                                <rect id="Icons" rx="0.000000" width="23.000000" height="23.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                            </clipPath>
                        </defs>
                        <rect id="Icons" rx="0.000000" width="23.000000" height="23.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                        <g clip-path="url(#clip409_2813)">
                            <path id="Union" d="M19.18 11.24L14.46 6.52L15.53 5.46L21.53 11.46L22.06 11.99L21.53 12.52L15.53 18.52L14.46 17.46L19.18 12.74L3 12.74L3 11.24L19.18 11.24Z" fill="#1D1D34" fill-opacity="1.000000" fill-rule="evenodd"/>
                        </g>
                    </svg>    
                </router-link>
            </div>
            <router-link :to="{
                    name: 'ArticleBlog',
                    params: {
                    slug: item.slug
                    },
                }">  
            </router-link>
        </div>
    </div>
</template>

<script>
import axios from "axios";
    export default {
        props: {
            array: [Array, Object],
        },

    }
</script>

<style scoped>
.left {
  width: 36%;
  max-width: 471px;
  padding-top: 19%;
  position: relative;
  overflow: hidden;
}
.left .simpleParallax{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}
.left img {
    position: absolute;
    left: 0;
    top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.blog__list{
    display: flex;
    flex-direction: column;
    gap: 32px;
}
.item{
    display: flex;
    justify-content: space-between;
    align-items: start;
    gap: 24px;
}
.item{
    position: relative;
}
.item > a{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.right{
    border-top: 1px solid rgb(222, 230, 234);
    padding-top: 18px;
    width: 49.4%;
    max-width: 647px;
}
.right .text{

color: rgb(85, 98, 114);
font-size: 13px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
text-transform: uppercase;
padding-bottom: 16px;
}
.right .title{

color: rgb(5, 5, 5);
font-size: 24px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 16px;
}
.right .desc{

color: rgb(85, 98, 114);
font-size: 16px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
margin-bottom: 24px;
text-align: left;
max-height: 40px;

-webkit-line-clamp: 2;
line-clamp: 2;
display: -webkit-box;
-webkit-box-orient: vertical;
overflow: hidden;
}
.right a{
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(244, 245, 247);
    width: 56px;
    height: 56px;
    border-radius: 100%;
}
@media (max-width: 1078px) {
    .left{
        width: 41%;
        padding-top: 25%;
    }
}
@media (max-width: 1024px) {
    .left{
        width: 41%;

    }
    .right{
        width: 55%;
    }
}
@media (max-width: 768px) {
    .item{
        flex-direction: column;
    }
    .left{
        width: 100%;
        max-width: unset;
        max-height: 400px;
        height: 100%;
        padding-top: 50%;
    }
    .right{
        width: 100%;
        max-width: unset;
    }
}
</style>